import React, {useEffect, useRef, memo} from 'react';
import {useDispatch, useSelector} from "react-redux";
import BrowsemodePaneComponent from "../BrowsemodePaneComponent";
import {ApplicationState} from "../../../store";
import { startBrowsePane, bwsAddTimeStrips, errorBrowsePane } from "../../../store/browse/actions";
import {getBrowseStreamFromCamera, getLocalBounds, chooseService} from "../../../utils";
import {APIState} from "../../../store/API/types";
import SelectCameraComponent from "../../reusable/SelectCameraComponent";
import ThumbnailComponent from "../ThumbnailComponent";
import {setCurrentCamera} from "../../../store/cameras/actions";
import {BrowseState} from "../../../store/browse/types";
import { LayoutState } from '../../../store/layouts/types';
import { CamerasState } from '../../../store/cameras/types';
import BrowsemodeMainPaneComponent from '../BrowsemodeMainPaneComponent';

interface Props {
    pane: number,
    isThumbnail: boolean
}

const InitBrowsePaneComponent: React.FC<Props> = ({pane, isThumbnail}) => {
    const dispatch = useDispatch();
    const { browsePanes, draggableCamId } = useSelector<ApplicationState, BrowseState>(state => state.browse);
    const { currentCameras } = useSelector<ApplicationState, CamerasState>(state => state.cameras);
    const { initialCameras } = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    const { cameras } = useSelector<ApplicationState, APIState>(state => state.API);
    const ref = useRef<HTMLDivElement>(null);
    const cam = !isThumbnail ? currentCameras[pane] : initialCameras[pane - 2];
    const enable = browsePanes[pane];

    // TODO
    // Finish setting up browse cameras on reload

    useEffect(() => {
        if (cam) {
            const { width } = getLocalBounds(ref.current);
            const { error, stream } = chooseService(
                () => getBrowseStreamFromCamera(cameras, cam.id),
                () => ({error: false, stream: {stream_id: null}})
            );

            if (!error && cam) {
                dispatch(startBrowsePane({
                    pane: pane,
                    width: Math.floor(width),
                    height: Math.floor(width / 16 * 9),
                    camId: cam.id,
                    streamId: stream.stream_id
                }));
            } else if (error) {
                dispatch(errorBrowsePane(pane));
            }
        }
    }, [cam]);

    const PaneComponent = ((pane === 0 || pane === 1) && !isThumbnail)
        ? BrowsemodeMainPaneComponent
        : ThumbnailComponent;

    const onDragOver = (e: React.MouseEvent) => {
        if (isThumbnail) return;
        if (ref.current) ref.current.style.opacity = '1';
        e.preventDefault();
    };

    const onDragLeave = () => {
        if (ref.current) ref.current.style.opacity = '0.5';
    };

    const onDrop = (e: React.MouseEvent) => {
        if (draggableCamId && cam !== draggableCamId) {
            dispatch(setCurrentCamera(draggableCamId, pane));
            dispatch(bwsAddTimeStrips(pane, [], null));
        }
    };

    return (
        <div ref={ref}
             className='w-100 h-100 fadeable'
             onDragOver={onDragOver}
             onDragLeave={onDragLeave}
             onDrop={onDrop}
        >
            {
                (enable && (isThumbnail ? true : currentCameras[pane]))
                    ? isThumbnail 
                        ? initialCameras[pane - 2] 
                            ? <PaneComponent pane={pane} cam={cam} />
                            : <SelectCameraComponent />
                        : <PaneComponent pane={pane} cam={cam} />
                    : <SelectCameraComponent />
            }
        </div>
    )
};

export default memo(InitBrowsePaneComponent);